import { useAccountSettingsQuery } from "../../../../SWR/AccountSettings/useAccountSettingsQuery";
import { AccountRoutesType, getNavItems } from "../navigationUtils";
export const useNavLinks = () => {
    var _a, _b, _c;
    const { accountSettings } = useAccountSettingsQuery();
    const { HideBillingInformation = false, HideMyMeals = false, HideAddresses = false, HideSkipDays = false, HideSubscriptions = false, MyMealsLinkText, } = accountSettings !== null && accountSettings !== void 0 ? accountSettings : {};
    const navItems = getNavItems(MyMealsLinkText);
    const createFilters = (filterMap) => filterMap;
    const topFilters = createFilters({
        [AccountRoutesType.MY_MEALS]: HideMyMeals,
        [AccountRoutesType.SKIP_DAYS]: HideSkipDays,
        [AccountRoutesType.SUBSCRIPTIONS]: HideSubscriptions,
        [AccountRoutesType.LOGOUT]: true,
        [AccountRoutesType.ACCOUNT_MENU]: true, // Exclude from top links
    });
    const bottomFilters = createFilters({
        [AccountRoutesType.BILLING_INFO]: HideBillingInformation,
        [AccountRoutesType.ADDRESSES]: HideAddresses,
    });
    const navBarFilters = createFilters(Object.assign(Object.assign({}, topFilters), { [AccountRoutesType.ACCOUNT_MENU]: false }));
    const filterNavItems = (items, filters) => items.filter((nav) => !filters[nav.to]);
    const navBarLinks = filterNavItems(navItems, navBarFilters);
    const navDrawerTopLinks = filterNavItems(navItems, topFilters);
    const navDrawerBottomLinks = (_c = (_b = (_a = navItems
        .find((nav) => nav.to === AccountRoutesType.ACCOUNT_MENU)) === null || _a === void 0 ? void 0 : _a.menuItems) === null || _b === void 0 ? void 0 : _b.filter((nav) => !bottomFilters[nav.to])) !== null && _c !== void 0 ? _c : [];
    return {
        navBarLinks,
        navDrawerTopLinks,
        navDrawerBottomLinks,
        hideAddresses: HideAddresses,
        hideBillingInformation: HideBillingInformation,
    };
};
